import React, { PureComponent } from 'react';
import TabbedComponents from '../components/TabbedComponents';
import ComponentIndexRow from '../components/ComponentIndexPage/ComponentIndexRow';
import { BASE_URL } from '../config';
require('!style!css!less!../css/component-index.less'); // eslint-disable-line
require('!style!css!less!../css/table.less'); // eslint-disable-line

export default class ComponentIndexPage extends PureComponent {
  state = {
    components: [],
  };

  componentDidMount() {
    fetch(`${BASE_URL}/spa_data/components_page.json`)
      .then(result => result.json())
      .then((json) => {
        this.setState({
          components: json,
        });
      });
  }

  render() {
    const { components, searchString } = this.state;

    return (
      <div>
        <h2 style={{margin: '28px 10px 26px 10px'}}>Components</h2>
        <TabbedComponents
          components={components}
          search={searchString}
          row={ComponentIndexRow}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ComponentIndexPage.jsx